import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { checkOauthConnectionQueryOptions } from "../../../api/useCheckOauthConnection";
import LoadingScreen from "../../../features/Layout/LoadingScreen/LoadingScreen";

export const Route = createFileRoute("/(app)/admin/organizations")({
  component: RouteComponent,
});

function RouteComponent() {
  const { isSuccess: pipedriveSuccess, isPending: pipedrivePending } = useQuery(
    checkOauthConnectionQueryOptions({ provider: "pipedrive" })
  );
  if (pipedrivePending) return <LoadingScreen />;

  // if (!pipedriveSuccess)
  //   return <AdminClientsOauthPage authenticatedPipedrive={pipedriveSuccess} />;

  return <Outlet />;
}
